import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectReplaceAlertMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_REPLACE_ALERT_MESSAGE);
        this.InstrumentTradableID = -1;
        this.RouteId = null;
        this.AlertId = -1;
        this.AlertType = null;
        this.AlertCondition = null;
        this.AlertValue = null;
        this.AlertImportance = null;
        this.Date = null;
        this.AlertAfterExecute = null;
        this.AlertAction = null;
        this.AlertNotification = null;
        this.Text = null;
        this.IsAllowOTHTrading = null;
    }
}
